import { render } from "./ProjectAccessModal.vue?vue&type=template&id=45a92294&scoped=true"
import script from "./ProjectAccessModal.vue?vue&type=script&lang=js"
export * from "./ProjectAccessModal.vue?vue&type=script&lang=js"

import "./ProjectAccessModal.vue?vue&type=style&index=0&id=45a92294&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a92294"]])

export default __exports__